import { FormDrawerContent, FormFetchDrawer, IShowEndpoint, TextField, UpdateDrawerFormProps } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IInvitationListShowResource } from "../../../shared/types/invitationList";
import { AttendanceSelectField } from "./AttendanceSelectField";

interface Props {
	service: IShowEndpoint<IInvitationListShowResource>;
}
export const InvitationListUpdateDrawer: FC<UpdateDrawerFormProps<IInvitationListShowResource> & Props> = (props) => {
	const { t } = useTranslation();

	return (
		<FormFetchDrawer
			{...props}
			title={t("Update invitation list entry")}
			queryFn={() => props.service.show(props.id).then((x) => x.data.data)}
			queryKey={props.service.showKey(props.id)}
			validate={(values) => {
				const errors: { [K in keyof typeof values]?: any } = {};

				if (!values.personCount) {
					errors.personCount = t("Required field");
				}
				if (values.personCount < 0) {
					errors.personCount = t("The value has to be greater than 0");
				}
				return errors;
			}}
			renderSuccess={(props) => (
				<FormDrawerContent {...props}>
					<TextField name="personCount" label={t("Person count")} type="number" />
					<AttendanceSelectField />
				</FormDrawerContent>
			)}
		/>
	);
};
